const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPaletteOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ionicons-v5-m") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M430.11,347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1,0-43.8l30.3-26.9c46.4-41,46.4-108.2,0-149.2-34.2-30.1-80.1-45-127.8-45-55.7,0-113.9,20.3-158.8,60.1-83.5,73.8-83.5,194.7,0,268.5,41.5,36.7,97.5,55,152.9,55.4h1.7c55.4,0,110-17.9,148.8-52.4C444.41,382.9,442,359,430.11,347.9Z",
    style: {
      fill: "none",
      stroke: "#F6C476",
      strokeMiterlimit: 10,
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6C476"
    },
    cx: 144,
    cy: 208,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6C476"
    },
    cx: 152,
    cy: 311,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6C476"
    },
    cx: 224,
    cy: 144,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6C476"
    },
    cx: 256,
    cy: 367,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6C476"
    },
    cx: 328,
    cy: 144,
    r: 32
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPaletteOutline);
export default __webpack_public_path__ + "static/media/color-palette-outline.cb56dc408e9369b2bcb5ad2994bac989.svg";
export { ForwardRef as ReactComponent };